import { useCallback, useEffect, useMemo, useState } from "react";
import styled from "styled-components";
import SortableTable from "../../../Componentes/Utils/SortableTable";
import useApi from "../../../hooks/useApi";

const PageContent = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    gap: 10px;
    box-sizing: border-box;
    overflow: hidden;
`;

const TableFlexFill = styled.div`
    flex: 1;
    min-height: 0;
    width: 100%;
    display: flex;
    flex-direction: column;

    & > div {
        flex: 1;
        min-height: 0;
        display: flex;
        flex-direction: column;
    }
`;

const Content = ({ refreshKey = 0 }) => {
    const api = useApi();
    const [loading, setLoading] = useState(true);
    const [prossmaps, setProssmaps] = useState([]);

    const fetchProssmaps = useCallback(async () => {
        setLoading(true);
        try {
            const { data } = await api.get("/Painel/API/Prossmap/List/index.php");
            const lista = data?.data ?? data;
            setProssmaps(Array.isArray(lista) ? lista : []);
        } catch (error) {
            console.error("Erro ao listar PROSSMAPs:", error);
            setProssmaps([]);
        } finally {
            setLoading(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        fetchProssmaps();
    }, [fetchProssmaps, refreshKey]);

    const columns = useMemo(
        () => [
            {
                id: "id",
                header: "ID",
                accessor: "id",
                sortable: true,
                width: "70px",
                align: "center",
            },
            {
                id: "equipe",
                header: "EQUIPE",
                accessor: "equipe",
                sortable: true,
            },
            {
                id: "encarregado",
                header: "ENCARREGADO",
                accessor: "encarregado_nome",
                sortable: true,
            },
            {
                id: "matricula",
                header: "MATRÍCULA",
                accessor: "encarregado_matricula",
                sortable: true,
                width: "110px",
            },
            {
                id: "referencia",
                header: "MÊS REFERÊNCIA",
                accessor: "referencia_mes_label",
                sortable: true,
                width: "140px",
                align: "center",
            },
            {
                id: "pontos",
                header: "PONTOS",
                accessor: "pontos_obtidos",
                sortable: true,
                width: "100px",
                align: "center",
            },
            {
                id: "status",
                header: "STATUS",
                accessor: "status",
                sortable: true,
                width: "140px",
            },
        ],
        []
    );

    const handleRowClick = (row) => {
        if (!row?.id) return;
        window.open(`/modulo/ssma/prossmap/${row.id}`, "_blank", "noopener,noreferrer");
    };

    return (
        <PageContent>
            <TableFlexFill>
                <SortableTable
                    columns={columns}
                    data={prossmaps}
                    isLoading={loading}
                    loadingText="Carregando PROSSMAPs..."
                    emptyText="Nenhum PROSSMAP encontrado."
                    initialSort={{ key: "referencia", direction: "desc" }}
                    getRowId={(row) => row.id}
                    onRowClick={handleRowClick}
                    rowCursor="pointer"
                />
            </TableFlexFill>
        </PageContent>
    );
};

export default Content;
